import { DictionaryEntry } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';

export class ProcessingStatusModel implements MasterDetailListEntry {

    id: number;
    nameDictionaryKey: string;
    translatedLabel: string;

    constructor(model: any) {
        if (model != null) {
            this.id = model.id;
            this.nameDictionaryKey = model.nameDictionaryKey;
        }
    }

    public get listTitle(): string {
        return this.translatedLabel;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }
}

export class ProcessingStatus {

    id: number;
    key: string;
    index: number;
    name = new DictionaryEntry();
    forward = new DictionaryEntry();
    backward = new DictionaryEntry();
    deleted = false;
    color: string;

    constructor(status?: any) {
        if (status != null) {
            this.id = status.id;
            this.key = status.key;
            this.index = status.index;
            this.name = new DictionaryEntry(status.name);
            this.forward = new DictionaryEntry(status.forward);
            this.backward = new DictionaryEntry(status.backward);
            this.color = status.color;
        }
    }

}

export class ProcessingStatusModelDetails {

    id: number;
    key: string;
    name = new DictionaryEntry();
    index: number;
    processingStatus = new Array<ProcessingStatus>();
    deactivated = false;

    constructor(details?: any) {
        if (details != null) {
            this.id = details.id;
            this.key = details.key;
            this.name = new DictionaryEntry(details.name);
            this.index = details.index;
            this.deactivated = details.deactivated;

            if (details.processingStatus != null) {
                for (const status of details.processingStatus) {
                    this.processingStatus.push(new ProcessingStatus(status));
                }
            }
        }
    }
}
